import React, { useState } from 'react';

function EbecoAuth({ saveCredentials }) {
  const [userName, setUserName] = useState('');
  const [passWord, setPassWord] = useState('');
  const [saveStatus, setSaveStatus] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    // Check if credentials are provided
    if (!userName.trim() || !passWord.trim()) {
      alert('Please enter both username and password');
      return;
    }

    setIsSaving(true);
    setSaveStatus('Saving...');

    const result = await saveCredentials('ebeco_credentials', {
      username: userName,
      password: passWord
    });

    setSaveStatus(result.message);

    if (result.success) {
      // Clear the form after successful save
      setTimeout(() => {
        setUserName('');
        setPassWord('');
        setSaveStatus('');
      }, 2000);
    } else {
      setTimeout(() => setSaveStatus(''), 3000);
    }

    setIsSaving(false);
  };

  return (
    <div className="provider-card">
      <h3 className="provider-title">Ebeco</h3>
      <div className="input-group">
        <label htmlFor="ebeco_userName" className="input-label">
          Username
        </label>
        <input
          id="ebeco_userName"
          type="text"
          className="input-field"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Enter your Ebeco username"
        />
      </div>
      <div className="input-group">
        <label htmlFor="ebeco_password" className="input-label">
          Password
        </label>
        <input
          id="ebeco_password"
          type="password"
          className="input-field"
          value={passWord}
          onChange={(e) => setPassWord(e.target.value)}
          placeholder="Enter your Ebeco password"
        />
      </div>
      <button
        onClick={handleSave}
        className="auth-button"
        disabled={isSaving}
      >
        {isSaving ? 'Saving...' : 'Save'}
      </button>
      {saveStatus && (
        <div className={`save-status ${saveStatus.includes('Error') ? 'error' : 'success'}`}>
          {saveStatus}
        </div>
      )}
    </div>
  );
}

export default EbecoAuth;